import React from 'react';
import { FooterSection, BreadCrumb, StaticPageHeader } from '../components';
import { getAppEnv } from '../../../config/env';
import { StaticListIndexData, EnvironmentVariables } from '../types';
import RefundRules from './RefundRules';
import DataLoaderError from '../../errors/DataLoaderError';
import { RECOMMEND_PATH } from '../components/RecommendTripPathList/utils/recommendTripPathListUtils';
import RecommendTripPathWrapper from '../components/RecommendTripPathList/RecommendTripPathList';
import HtmlHeader from '../components/HtmlHeader';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';

const env = getAppEnv();
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;

type StaticListIndexProps = {
  data: StaticListIndexData;
};

StaticReservationCancellation.fetchData = async function (_, __, urlObj): Promise<StaticListIndexData> {
  const pageType = `trains`;
  const urlString = `${DATA_LOADER_URL}/api/getIndexPageData/${pageType}/ENGLISH`;
  let responseData;
  const response = await fetch(urlString);
  const textResponse = await response.text();
  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new DataLoaderError(`Unable to fetch train list`, responseData.error);
  }
  const cacheKey = 'HTML_STATIC_RAILWAY-RESERVATION-CANCELLATION.HTML';
  responseData.template.meta_title = 'Railway Reservation Cancellation - MakeMyTrip';
  responseData.template.meta_description =
    'Confirmed Railways eticket reservation can be cancelled online. Indian Railways have set up rules of cancellation which are as below:   1. 24 hours prior to the time of departure: If the ticket is cancelled 24 hours prior to departure, there are no cancellation charges. However, service charges and transaction charges for booking the ticket is not refundable';
  responseData.template.analytics = getStaticPageLoadEvent('seo:domestic rails:Railway Reservation Cancellation');
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...responseData
  };
};
function StaticReservationCancellation({ data }: StaticListIndexProps) {
  return (
    <>
      <div className="container">
        <HtmlHeader data={data} />
        <main>
          <div className="railSeoWrapper">
            <BreadCrumb breadcrumb={data.template.breadcrumb} templateName={'Railway Reservation Cancellation'} />
            <StaticPageHeader title={'Railway Reservation Cancellation'} />
            <br />
            <div className="railDataBox">
              <RefundRules />
            </div>

            <section className="railSeoWrap__stnDetails makeFlex spaceBetween">
              <RecommendTripPathWrapper recommendPaths={RECOMMEND_PATH.STATIC_RESERVATION_CANCEL(data)} />
            </section>
          </div>
        </main>
      </div>
      <FooterSection template={data.template} />
    </>
  );
}

export default StaticReservationCancellation;
